import type { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import headerStyle from 'app/components/DesignVersion/Grad/OpponentsHeader/style.module.scss';

import style from './style.module.scss';

interface Props extends PropsWithChildren {
  // Economy row rendered below the team infos — repositions the glow pseudo-elements.
  hasEconomy?: boolean;
}

const ScoreCard: FC<Props> = ({ hasEconomy = false, children }) => (
  <div
    className={classNames(headerStyle.opponentsHeader, style.scoreCard, {
      [style.hasEconomy]: hasEconomy
    })}
  >
    {children}
  </div>
);

ScoreCard.displayName = 'ScoreCard';

export default ScoreCard;
